import {
  setCookie,
  getCookie,
  setHeaderAuthorization,
  deleteHeaderAuthorization
} from '../../../utils/request'
import { TOKEN_NAME } from '../../../utils/constants'

const mutations = {
  updateToken: (state, token) => {
    if (!token) {
      token = getCookie(TOKEN_NAME)
    }
    state.token = token
    if (state.token) {
      setHeaderAuthorization(token)
      state.isAuthenticated = true
      setCookie(TOKEN_NAME, token, 1)
    }
  },
  updateAuthenticate: (state, status) => {
    state.isAuthenticated = status
  },
  updateUserInfo: (state, userInfo) => {
    state.userInfo = userInfo
  },
  clearUserInfo: (state) => {
    state.token = ''
    state.isAuthenticated = false
    state.userInfo = {}
    deleteHeaderAuthorization()
  },
  setUserRoles: (state, userRoles) => {
    state.userRoles = userRoles
  }
}
export default mutations
